import { utilsModule } from "../utils-module";

utilsModule.factory('localSettingsService', ['$q','localStorageService','printerService','loaderService','$filter','blockService','parameterService','LoggedUserService',function($q,localStorageService,printerService,loaderService,$filter,blockService,parameterService,LoggedUserService){

	return {
		getLoggedUser: function(){
			return localStorageService.get('loggedUser');
		},

		setLoggedUser: function(user){
			localStorageService.set('loggedUser',user);
		},
        
        setLoggedUserType: function(type) {
            localStorageService.set('loggedUserType',type);
        },
        
        getLoggedUserType: function(){
            return localStorageService.get('loggedUserType');
        },

		setPrintOnStart: function(print){
			localStorageService.set('printOnStart',(print !== undefined) ? print : true);
		},

		setPrintOnConclude: function(print){
			localStorageService.set('printOnConclude',(print !== undefined) ? print : true);
		},

		setPrintOnDistributeTurn: function(print){
			localStorageService.set('printOnDistTurn',(print !== undefined) ? print : true);
		},

		/**
		@param {object} orderType: vide orderTypeService.orderTypes
		**/
		setPrintOnOrder: function(print,orderType){
			var capitalized = $filter('capitalize')(orderType.verb);
			localStorageService.set('printOn' + capitalized,(print !== undefined) ? print : true);	
		},

		/**
		@param {object} orderType: vide orderTypeService.orderTypes
		**/
		setPrintClientCopy: function(print,orderType){
			var capitalized = $filter('capitalize')(orderType.name.singular);
			localStorageService.set('printClientCopy' + capitalized,(print !== undefined) ? print : true);	
		},

		/**
		@param {object} orderType: vide orderTypeService.orderTypes
		**/
		setPrintCheckerCopy: function(print,orderType){
			var capitalized = $filter('capitalize')(orderType.name.singular);
			localStorageService.set('printCheckerCopy' + capitalized,(print !== undefined) ? print : true);	
		},

		/**
		@param {object} orderType: vide orderTypeService.orderTypes
		**/
		setUseDefaultGroup: function(use,orderType){
			var capitalized = $filter('capitalize')(orderType.verb);
			localStorageService.set('useDafaultGroup' + capitalized,(use !== undefined) ? use : true);	
		},

		/**
		@param {object} orderType: vide orderTypeService.orderTypes
		**/
		setAutoConcludeEnabled: function(enabled,orderType){
			var capitalized = $filter('capitalize')(orderType.verb);
			localStorageService.set('autoConclude' + capitalized,(enabled !== undefined) ? enabled : true);	
		},

		/**
		@param {object} orderType: vide orderTypeService.orderTypes
		**/
		setAutoExportEnabled: function(enabled,orderType){
			var capitalized = $filter('capitalize')(orderType.verb);
			localStorageService.set('autoExport' + capitalized,(enabled !== undefined) ? enabled : true);	
		},

		/**
		@param {object} orderType: vide orderTypeService.orderTypes
		**/
		isPrintOnStart: function(){
			var print = localStorageService.get('printOnStart');
			return (print !== undefined) ? print : true;
		},


		isPrintOnConclude: function(){
			var print = localStorageService.get('printOnConclude');
			return (print !== undefined) ? print : true;
		},

		isPrintOnDistributeTurn: function(){
			var print = localStorageService.get('printOnDistTurn');
			return (print !== undefined) ? print : true;
		},

		/**
		@param {object} orderType: vide orderTypeService.orderTypes
		**/
		isPrintOnOrder: function(orderType){
			var capitalized = $filter('capitalize')(orderType.verb);
			var print = localStorageService.get('printOn' + capitalized);
			return (print !== undefined) ? print : true;
		},

		/**
		@param {object} orderType: vide orderTypeService.orderTypes
		**/
		isPrintClientCopy: function(orderType){
			var capitalized = $filter('capitalize')(orderType.name.singular);
			var print = localStorageService.get('printClientCopy' + capitalized);
			return (print !== undefined) ? print : true;
		},

		/**
		@param {object} orderType: vide orderTypeService.orderTypes
		**/
		isPrintCheckerCopy: function(orderType){
			var capitalized = $filter('capitalize')(orderType.name.singular);
			var print = localStorageService.get('printCheckerCopy' + capitalized);
			return (print !== undefined) ? print : true;
		},

		/**
		@param {object} orderType: vide orderTypeService.orderTypes
		**/
		isUseDefaultGroup: function(orderType){
			var capitalized = $filter('capitalize')(orderType.verb);
			var use = localStorageService.get('useDafaultGroup' + capitalized);
			return (use !== undefined) ? use : true;
		},		

		/**
		@param {object} orderType: vide orderTypeService.orderTypes
		**/
		isAutoConcludeEnabled : function(orderType){
			var capitalized = $filter('capitalize')(orderType.verb);
			var enabled = localStorageService.get('autoConclude' + capitalized);
			return (enabled !== undefined) ? enabled : false;
		},

		/**
		@param {object} orderType: vide orderTypeService.orderTypes
		**/
		isAutoExportEnabled : function(orderType){
			var capitalized = $filter('capitalize')(orderType.verb);
			var enabled = localStorageService.get('autoExport' + capitalized);
			return (enabled !== undefined) ? enabled : false;
		},

		/**
		@param {object} orderType: vide orderTypeService.orderTypes
		**/
		setDefaultOrderBlock: function(block,orderType){
			var capitalized = $filter('capitalize')(orderType.verb);
			localStorageService.set('defaultOrderBlockCode' + capitalized,block ? block.id : undefined);
		},

		/**
		@param {object} orderType: vide orderTypeService.orderTypes
		**/
		getDefaultOrderBlock: function(orderType){
			var deferred = $q.defer();
			var capitalized = $filter('capitalize')(orderType.verb);
			var blockCode = localStorageService.get('defaultOrderBlockCode'+capitalized);

			if (!blockCode)
				deferred.resolve(undefined);

			blockService.listCached().then(
				function(list){
					for (var i in list){
						var block = list[i];
						if (block.id == blockCode)
							deferred.resolve(block);
					}
					deferred.resolve(undefined);
				},function(){
					deferred.reject();
				}
			);
			return deferred.promise;
		},

		getOrderBlockToUse : function(orderType){
			var d = $q.defer();
			this.getDefaultOrderBlock(orderType).then(function(block){
				if (block){
					d.resolve(block);
				}else{
					parameterService.getDefaultOrderBlock(orderType.orderTypeId)
					.then(function(block){
						d.resolve(block);
					})
					.catch(function(err){
						d.reject(err);
					});
				}			
			});
			return d.promise;
		},

		setSelectedPrinter: function(printer){
			localStorageService.set('selectedPrinter',printer ? printer : 'undefined');
		},

		getSelectedPrinter: function(){
			var printer = localStorageService.get('selectedPrinter');
			return (printer && printer !== 'undefined') ? printer : undefined;
		},

		setSelectedDistributionPrinter: function(printer){
			localStorageService.set('selectedDistPrinter',printer ? printer : 'undefined');
		},

		getSelectedDistributionPrinter: function(){
			var printer = localStorageService.get('selectedDistPrinter');
			return (printer && printer !== 'undefined') ? printer : undefined;
		},

		/**
		@param {object} orderType: vide orderTypeService.orderTypes
		**/
		setSelectedOrderPrinter: function(printer,orderType,copy){
			var capitalized = $filter('capitalize')(orderType.name.plural);
			var capitalizedCopy = copy ? $filter('capitalize')(copy) + 'Copy' : '';
			localStorageService.set('selected' + capitalized + 'Printer' + capitalizedCopy,printer ? printer : 'undefined');
		},

		/**
		@param {object} orderType: vide orderTypeService.orderTypes
		**/
		getSelectedOrderPrinter: function(orderType,copy){
			var capitalized = $filter('capitalize')(orderType.name.plural);
			var capitalizedCopy = copy ? $filter('capitalize')(copy) + 'Copy' : '';
			var printer = localStorageService.get('selected' + capitalized + 'Printer' + capitalizedCopy);
			return (printer && printer !== 'undefined') ? printer : undefined;
		},

		/**
		 * @param {object} selectedPrintType the selected printer type
		 * @param {object} orderType vide orderTypeService.orderTypes
		 **/
		setSelectedPrintType: function(selectedPrintType,orderType){
			var capitalized = $filter('capitalize')(orderType.name.plural);
			localStorageService.set('selected' + capitalized + 'PrintType',selectedPrintType ? selectedPrintType : 'undefined');
		},

		/**
		 * @param {object} orderType: vide orderTypeService.orderTypes
		 * @return {string|undefined} the print type for the orderTpe: ('pdf','printer' or 'both');
		 **/
		getSelectedPrintType: function(orderType){
			var capitalized = $filter('capitalize')(orderType.name.plural);
			var printType = localStorageService.get('selected' + capitalized + 'PrintType');
			return (printType && printType !== 'undefined') ? printType : undefined;
		},

		getSelectedPrinterObj: function(){
			var deferred = $q.defer();
			var selectedPrinterId = localStorageService.get('selectedPrinter');
			if (selectedPrinterId && (selectedPrinterId !== 'undefined')){
				printerService.getCached(selectedPrinterId).then(function(printer){
					deferred.resolve(printer);
				},function(err){
					deferred.reject(err);
				});
			}else{
				deferred.resolve(undefined);
			}
			return deferred.promise;
		},

		getSelectedDistributionPrinterObj: function(){
			var deferred = $q.defer();
			var selectedPrinterId = localStorageService.get('selectedDistPrinter');
			if (selectedPrinterId && (selectedPrinterId !== 'undefined')){
				printerService.getCached(selectedPrinterId).then(function(printer){
					deferred.resolve(printer);
				},function(err){
					deferred.reject(err);
				});
			}else{
				deferred.resolve(undefined);
			}
			return deferred.promise;
		},

		getSelectedOrderPrinterObj: function(orderType,copy){
			var deferred = $q.defer();
			var capitalized = $filter('capitalize')(orderType.name.plural);
			var capitalizedCopy = copy ? $filter('capitalize')(copy) + 'Copy' : '';
			var selectedPrinterId = localStorageService.get('selected' + capitalized + 'Printer' + capitalizedCopy);
			if (selectedPrinterId && (selectedPrinterId !== 'undefined')){
				printerService.getCached(selectedPrinterId).then(function(printer){
					deferred.resolve(printer);
				},function(err){
					deferred.reject(err);
				});
			}else{
				deferred.resolve(undefined);
			}
			return deferred.promise;
		},

		setDefaultLoaderInDistribution : function(loader){
			localStorageService.set('defaultLoaderCodeInDistribution',loader ? loader.id : undefined);
		},

		getDefaultLoaderInDistribution : function(){
			var deferred = $q.defer();
			var loaderCode = localStorageService.get('defaultLoaderCodeInDistribution');

			if (!loaderCode)
				deferred.resolve(undefined);

			loaderService.listCached().then(
				function(list){
					for (var i in list){
						var loader = list[i];
						if (loader.id == loaderCode)
							deferred.resolve(loader);
					}
					deferred.resolve(undefined);
				},function(){
					deferred.reject();
				}
			);
			return deferred.promise;
		},
		

		setConcludeDistributionOnStart : function(conclude){
			localStorageService.set('concludeDistributionOnStart',conclude || false);
		},

		isConcludeDistributionOnStart : function(conclude){
			return (localStorageService.get('concludeDistributionOnStart') || false);
		}

	}
}]);